import { PolicyLink, RefundLink, TermsLink } from '@/widgets/policy';
import { selectedPlanAtom } from '@features/Stripe/atoms';
import { FormattedMessage } from '@features/intl';
import { currencyReplacer } from '@mentalgrowth/web_utils';
import { useAtomValue } from 'jotai';
import { useMemo } from 'react';
import styles from './index.module.scss';

export const Disclaimer = () => {
  const { currency, fullPriceDiscount, billingPeriod, billingPeriodUnit } =
    useAtomValue(selectedPlanAtom);

  const currencySign = currencyReplacer(currency);

  const defaultText = useMemo(
    () => (
      <>
        Without cancellation, before the selected discounted intro plan ends, I
        accept that will automatically charge {currencySign}
        {fullPriceDiscount} (incl. VAT) every {billingPeriod}{' '}
        {billingPeriod > 1 ? billingPeriodUnit + 's' : billingPeriodUnit} until
        I cancel. The transaction will be converted into USD based on your
        bank’s exchange rate. You can cancel the subscription at any time at no
        additional cost by contacting{' '}
        <a href="mailto:support@youth-app.com">support@youth-app.com</a>
      </>
    ),
    [billingPeriodUnit, billingPeriod, fullPriceDiscount, currencySign],
  );

  return (
    <div className={styles.host}>
      <p className={styles.text}>
        <FormattedMessage
          id="Onboarding.Checkout.Terms"
          values={{
            terms: (
              <TermsLink place="checkout" className={styles.link}>
                <FormattedMessage id="Onboarding.Checkout.Terms.A" />
              </TermsLink>
            ),
            privacy: <PolicyLink place="checkout" className={styles.link} />,
            refund: (
              <RefundLink place="checkout" className={styles.link}>
                <FormattedMessage id="Onboarding.Checkout.Terms.B" />
              </RefundLink>
            ),
          }}
        />
      </p>
      <p className={styles.text}>
        {/*Youth will use your payment details for easy future payments. The*/}
        {/*transaction will be converted into USD based on your bank’s exchange rate.*/}
        {/*Subscriptions renew automatically at the end of each period unless you*/}
        {/*cancel at least 24 hours before the end of then-current period. To avoid*/}
        {/*being charged cancel your subscription by contacting our support at least*/}
        {/*24 hours before the end of then-current period. If you are unsure how to*/}
        {/*cancel, please contact our support via{' '}*/}
        {/*<a href="mailto:support@youth-app.com">support@youth-app.com</a> You may*/}
        {/*wish to make a screenshot of this information for your reference.*/}

        {defaultText}
      </p>
    </div>
  );
};
